import { render } from "./Dropdown.vue?vue&type=template&id=5074aa48&scoped=true"
import script from "./Dropdown.vue?vue&type=script&lang=js"
export * from "./Dropdown.vue?vue&type=script&lang=js"

import "./Dropdown.vue?vue&type=style&index=0&id=5074aa48&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5074aa48"]])

export default __exports__